import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
//import Milho from '../imagens/milho.jpeg';
//import Fava from '../imagens/fava.jpeg';
import FavaRajada from '../imagens/FavaRajada.png';
import Farinha from '../imagens/Farinha.png';
import FeijaoCarioca from '../imagens/FeijaoCarioca.png';
import FeijaoCavaloClaro from '../imagens/FeijaoCavaloClaro.png';
import FeijaoJalo from '../imagens/FeijaoJalo.png';
import FeijaoPreto from '../imagens/FeijaoPreto.png';
import Milho from '../imagens/Milho.png';
import MilhoPipoca from '../imagens/MilhoPipoca.png';
//import FeijaoCarioca from '../imagens/feijaocarioca.jpeg';
//import FeijaoPreto from '../imagens/feijaopreto.jpeg';
import FeijaoClaro from '../imagens/feijaoclaro.jpeg';
import Footer from '../components/Footer';
import Slide from '../components/slide';
import CarouselProdutos from '../components/carouselProdutos';


import Button from '../components/button';
import ButtonReceitas from '../components/buttonReceitas'

class Home extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            RecipesArray:[]
        }
        this.getRecipes = this.getRecipes.bind(this)
    }
    componentDidMount(){
        this.getRecipes()
    }
    getRecipes(){
        axios.get('https://infinite-thicket-90676.herokuapp.com/receitanews')
        .then(res => {
            const List = res.data;
            // console.log(List)
            this.setState({RecipesArray: List});
        })
        .catch(err => {
            console.log(err)
        })
        .finally(() => {
            // console.log(this.state.RecipesArray)
        })
    }
    
    render(){
        return(
        <div>
        <Slide/>
        <div className="container-fluid correçãoContainer">
            <div id="QUEMSOMOS" className="row">
                <div className="col-md-12 text-center">
                    <p className="textoP">QUEM SOMOS</p>
                    <h1 className="textoH">Fazendo Qualidade</h1>
                    <p style={{marginTop:40}}>
                        Fundada há 15 anos, a Dona Mariquinha está entre as principais empresas de alimentos do estado,<br/>
                        atuando no empacotamento de feijão, farinha, farofa e milho. Hoje estamos com 3 lojas,<br/>
                        localizadas na Ceasa/RN, Zona Norte e Parnamirim.  Desde de 2004 a Dona Mariquinha faz parte da família potiguar,<br/>
                        nascemos para entregar qualidade e praticidade para você, consumidor<br/>
                        Ao longo dos anos crescemos no mercado e nos tornamos referência em qualidade,<br/>
                        graças ao nosso cuidado com toda trajetória de produção de alimentos que oferecemos.<br/>
                    </p>
                    <button style={{marginBottom:40}} type="button" className="btn btn-outline-primary">SAIBA MAIS</button>
                </div>
            </div>
            </div>
                <div id="produtos" style={{ marginBottom: 0 }} className="jumbotron jumbotron-fluid">
                    <div className="container text-center">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className="textoH">Produtos</h1>
                                <br/>
                                <br/>
                            </div>
                        </div>

                        {/* MODAL DE CADA PRODUTO, MODIFICAR O ID AQUI E NO CARROUSEL */}
                        
                        {/* <div className="modal fade" id="ModalMilho" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Titulo modal</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                Conteudo modal
                            </div>
                            </div>
                        </div>
                        </div>
                        
                        <div className="modal fade" id="ModalFava" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Titulo modal</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                Conteudo modal
                            </div>
                            </div>
                        </div>
                        </div>
                        <div className="modal fade" id="ModalFeijaoC" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Titulo modal</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                Conteudo modal
                            </div>
                            </div>
                        </div>
                        </div>
                        <div className="modal fade" id="ModalFeijaoP" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Titulo modal</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                Conteudo modal
                            </div>
                            </div>
                        </div>
                        </div> */}
                        
                       <CarouselProdutos>
                       <div className="col-md-12">
                                <div className="card">
                                    <img className="card-img-top" src={Milho} style={{maxHeight: 400, height: 210}} alt="Card image cap"></img>
                                    <div className="card-body">
                                        <h5 className="card-title">Milho</h5>
                                        {/* <p className="card-text">Some quick example text to build.</p> */}
                                        <div>
                                        {/* <button type="button" className="btn btn-primary" data-toggle="modal" data-target="#ModalMilho">
                                        Ver mais
                                        </button> */}
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="card">
                                    <img className="card-img-top" src={FavaRajada} style={{maxHeight: 400, height: 210}} alt="Card image cap"></img>
                                    <div className="card-body">
                                        <h5 className="card-title">Fava</h5>
                                        {/* <p className="card-text">Some quick example text to build.</p> */}
                                        <div>
                                        {/* <button type="button" className="btn btn-primary" data-toggle="modal" data-target="#ModalFava">
                                        Ver mais
                                        </button> */}
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="card">
                                    <img className="card-img-top" src={FeijaoCarioca} style={{maxHeight: 400, height: 210}} alt="Card image cap"></img>
                                    <div className="card-body">
                                        <h5 className="card-title">Feijão Carioca</h5>
                                        {/* <p className="card-text">Some quick example text to build.</p> */}
                                        <div>
                                        {/* <button type="button" className="btn btn-primary" data-toggle="modal" data-target="#ModalFeijaoC">
                                        Ver mais
                                        </button> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="card">
                                    <img className="card-img-top" src={FeijaoPreto} style={{maxHeight: 400, height: 210}} alt="Card image cap"></img>
                                    <div className="card-body">
                                        <h5 className="card-title">Feijão Preto</h5>
                                        {/* <p className="card-text">Some quick example text to build.</p> */}
                                        <div>
                                        {/* <button type="button" className="btn btn-primary" data-toggle="modal" data-target="#ModalFeijaoP">
                                        Ver mais
                                        </button> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                       
                       </CarouselProdutos>
                        
                    </div>
                </div>
                <div style={{ backgroundColor: '#0059be' }} className="jumbotron-fluid">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <h1 style={{ marginTop: 100 , color: 'white', fontWeight:'normal' }} className="textoH">Receitas</h1>
                                <p  style={{color: 'white', fontWeight:'normal' }}>
                                    Confira as melhores receitas, <br/>
                                    para os mestres da cozinha. <br/>
                                    com os produtos dona mariquinha. <br/>
                                </p>
                                <Link to="/receitas" style={{padding:0}} className="nav-link"><button style={{marginBottom:40}} type="button" className="btn btn-outline-primary">VEJA TODAS</button></Link>
                                
                            </div>
                            {this.state.RecipesArray.reverse().slice(0,4).map((receitas, index) => {
                                return(
                                    <div key={index} style={{ marginTop: 50, marginBottom:50 }} className="col-md-3">
                                    <div className="card-deck">
                                        <div key={receitas.id} className="card">
                                            <img className="card-img-top" src={receitas.imagem_url} alt={receitas.nome}></img>
                                            <div className="card-body">
                                            <h5 className="card-title">{receitas.nome}</h5>
                                                <p className="card-text">{receitas.descricao}</p>
                                            </div>
                                            <div style={{ marginLeft:1 }} className="card-footer row align-items-center justify-content-between">
                                                <i className="fas fa-user-alt"></i>
                                                <p className="textoReceitas">{receitas.qtd_pessoas}</p>

                                                <i  className="fas fa-stopwatch"></i>
                                                <p className="textoReceitas">{receitas.tempo}</p>

                                                <i  className="fas fa-fire-alt"></i>
                                                <p className="textoReceitas">{receitas.calorias}</p>

                                                <ButtonReceitas
                                                tituloModal={receitas.nome}
                                                index={index}
                                                descricaoModal =
                                                {
                                                    <div className="container-fluid">
                                                        <img style={{ width:'100%' }} src={receitas.imagem_url} alt={receitas.nome}></img>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <h1>Ingredientes</h1>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <p>{receitas.ingredientes}</p>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <h1>Modo de preparo</h1>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <p>{receitas.como_fazer}</p>
                                                            </div>
                                                        </div>
                                                        <div style={{width:'100%'}} className="card-footer row align-items-center">
                                                            <i style={{ marginLeft:'6%' }} className="fas fa-user-alt"></i>
                                                            <p className="textoReceitas">{receitas.qtd_pessoas}</p>

                                                            <i style={{ marginLeft:35 }} className="fas fa-stopwatch"></i>
                                                            <p className="textoReceitas">{receitas.tempo}</p>

                                                            <i style={{ marginLeft:35 }} className="fas fa-fire-alt"></i>
                                                            <p className="textoReceitas">{receitas.calorias}</p>
                                                        </div>
                                                    </div>
                                                }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div id ="contato" style={{width: "100%"}}>
                   <div className="row">
                       <div className="col-md-12">
                       <iframe width="100%"
                        height="600"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3969.2259901881944!2d-35.22708468461173!3d-5.823723995780148!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7b25567cc5ff69b%3A0x8f407b40ae1ddeb5!2sAv.%20Capit%C3%A3o-Mor%20Gouveia%2C%203005%20-%20Felipe%20Camar%C3%A3o%2C%20Natal%20-%20RN%2C%2025213-005!5e0!3m2!1spt-BR!2sbr!4v1596388492239!5m2!1spt-BR!2sbr"><a href="https://www.maps.ie/coordinates.html">gps coordinates</a>
                        </iframe>
                        <div className="maps text-center">
                        <h1 style={{marginTop: 50 , color: 'white', fontWeight:'normal' }} className="textoH">Fale Conosco</h1>
                            <p style={{color: 'white', fontWeight:'normal' }}>
                                Tem alguma dúvida ou sugestão?, <br/>
                                Clique no botão abaixo e nos <br/>
                                envie uma mensagem! <br/>
                            </p>
                            <Button
                            titulo="Mande uma mensagem"
                            tituloModal="Alguma dúvida ou sugestão?"
                            descricaoModal= {
                            <div>
                                <form action="https://formspree.io/victorandrademagalhaes@hotmail.com" method="POST">
                                <input className="form-control" type="text" name="name" placeholder="Nome"></input>
                                <br/>
                                <input className="form-control" type="email" name="_replyto" placeholder="Email"></input>
                                <br/>
                                <textarea className="form-control"  name="message" placeholder="Mensagem"></textarea>
                                <br/>
                                <input className="btn btn-primary" type="submit" value="Enviar"></input>
                                </form>
                            </div>
                            }
                            />
                       </div>
                       <div className="mapshide column text-center">
                           <div className="row">
                               <div className="col-md-12">
                               <h1 style={{marginTop: 50 , color: 'white', fontWeight:'normal' }} className="textoH">Fale Conosco</h1>
                                <p style={{color: 'white', fontWeight:'normal' }}>
                                    Lorem ipsum dolor sit amet, <br/>
                                    consectetur adipiscing elit. <br/>
                                    Curabitur vel consectetur dolor. <br/>
                                    Aliquam ut ex eros.
                                </p>
                               </div>
                            <div style={{marginTop:-50}}className="col-md-12">
                            <Button
                            titulo="Mande uma mensagem"
                            tituloModal="Alguma dúvida ou sugestão?"
                            descricaoModal= {
                            <div>
                                <form action="https://formspree.io/victorandrademagalhaes@hotmail.com" method="POST">
                                <input className="form-control" type="text" name="name" placeholder="Nome"></input>
                                <br/>
                                <input className="form-control" type="email" name="_replyto" placeholder="Email"></input>
                                <br/>
                                <textarea className="form-control"  name="message" placeholder="Mensagem"></textarea>
                                <br/>
                                <input className="btn btn-primary" type="submit" value="Enviar"></input>
                                </form>
                            </div>
                            }
                            />
                            </div>
                            </div>
                       </div>
                       </div>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Home;